export default __webpack_public_path__ + "static/media/avi.a31e1399.jpg";